import React, { useState } from 'react';
import { Play, X } from 'lucide-react';
import { videoUrl } from '../../data/mock';

const MediaSection = () => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  return (
    <section className="py-24 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center bg-blue-500/20 text-blue-300 px-4 py-2 rounded-full text-sm font-medium mb-6">
            Vidéo de présentation
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Découvrez le Keelcrab Pro en action
          </h2>
          <p className="text-blue-200 text-lg max-w-2xl mx-auto">
            Voyez comment notre technologie révolutionnaire nettoie les coques sans mise au sec.
          </p>
        </div>

        {/* Video Section */}
        <div className="max-w-4xl mx-auto">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl group">
            {/* Video Thumbnail */}
            <div className="relative aspect-video">
              <img
                src="https://img.youtube.com/vi/PwO5jUTyE9Y/maxresdefault.jpg"
                alt="Vidéo du drone Keelcrab"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-slate-900/50 group-hover:bg-slate-900/40 transition-colors flex items-center justify-center">
                <button
                  onClick={() => setIsVideoOpen(true)}
                  className="w-20 h-20 bg-blue-600 hover:bg-blue-500 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 shadow-2xl group-hover:shadow-blue-500/50"
                >
                  <Play className="w-8 h-8 text-white ml-1" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Video Modal */}
      {isVideoOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/90 backdrop-blur-sm">
          <div className="relative w-full max-w-5xl">
            <button
              onClick={() => setIsVideoOpen(false)}
              className="absolute -top-12 right-0 text-white hover:text-blue-400 transition-colors"
            >
              <X className="w-8 h-8" />
            </button>
            <div className="aspect-video rounded-2xl overflow-hidden shadow-2xl">
              <iframe
                src={`${videoUrl}?autoplay=1`}
                title="Drone Keelcrab en action"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default MediaSection;
